(function() {
  function setupCopyButton() {
    const host = document.querySelector('vip-app-referral-code');
    if (!host || !host.shadowRoot) return;

    const root = host.shadowRoot;

    const codeEl = root.querySelector('p.vip-app-referral-code-block_code');
    if (!codeEl) return;

    // 既にボタンがあれば二重追加しない
    if (root.querySelector('.vip-referral-copy-btn')) return;

    // 親コンテナ（コードと説明文などが入っている div）
    const block = root.querySelector('div.vip-app-referral-code-block');
    if (block) {
      // ここだけレイアウト指定（既存構造はいじらない）
      block.style.position = 'relative';
    }

    const btn = document.createElement('button');
    btn.textContent = 'コピー';
    btn.className = 'vip-referral-copy-btn';

    // ボタンの見た目 & 絶対配置
    btn.style.position = 'absolute';
    btn.style.left = '85px';
    btn.style.bottom = '-15px';
    btn.style.transform = 'translateY(-50%)';
    btn.style.padding = '4px 12px';
    btn.style.background = '#000';
    btn.style.color = '#fff';
    btn.style.fontSize = '12px';
    btn.style.border = 'none';
    btn.style.borderRadius = '4px';
    btn.style.cursor = 'pointer';

    // コード行にかぶらないよう、コード側に右余白だけ足す
    codeEl.style.paddingRight = '72px';

    // コンテナの末尾にボタンを追加（構造はほぼそのまま）
    if (block) {
      block.appendChild(btn);
    } else {
      codeEl.insertAdjacentElement('afterend', btn);
    }

    btn.addEventListener('click', async () => {
      const text = codeEl.textContent.trim();

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        }

        btn.textContent = 'コピーしました';
        setTimeout(() => btn.textContent = 'コピー', 2000);
      } catch (e) {
        console.error(e);
        btn.textContent = 'コピー失敗';
        setTimeout(() => btn.textContent = 'コピー', 2000);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupCopyButton();

    const observer = new MutationObserver(() => {
      setupCopyButton();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
// Judge.me 리뷰 배지 표시 제어
function showJdgmBadges() {
  document.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews]').forEach(el => {
    if (parseInt(el.getAttribute('data-number-of-reviews')) > 0) {
      el.style.setProperty('display', 'block', 'important');
    } else {
      el.style.setProperty('display', 'none', 'important');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  showJdgmBadges();
  setTimeout(showJdgmBadges, 500);
  setTimeout(showJdgmBadges, 1000);
  setTimeout(showJdgmBadges, 2000);
});

const observer = new MutationObserver(showJdgmBadges);
observer.observe(document.body, { childList: true, subtree: true });

// ── Globo Filter: 첫 렌더 완료 표식(html.gf-ready) ─────────────────────────────
// custom.css 가 Globo 활성 페이지에서 툴바 상품 개수(.gf-summary)를 gf-ready 전까지 숨긴다.
// Globo 는 상품·툴바(개수 포함)를 모두 그린 뒤 window 에 globoFilterRenderCompleted 를 발생시킨다.
// 폴백: 이벤트가 오지 않아도 8초 뒤 드러낸다 (Globo 로드 실패 시 화면이 비어 있지 않도록).
(function () {
  var html = document.documentElement;
  if (!html.classList.contains('spf-has-filter')) return;
  var ready = function () { html.classList.add('gf-ready'); };
  window.addEventListener('globoFilterRenderCompleted', ready, { once: true });
  if (document.querySelector('product-list product-card[data-gf-card]')) ready();
  setTimeout(ready, 8000);
})();
